
import styled from 'styled-components/macro'
import { useDispatch } from 'react-redux'
import { setFilter } from '../../redux/slices/categories'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import arrowDown from '../../assets/arrowSub.svg'
import arrowUp from '../../assets/arrowSubUp.svg'



const Root = styled.div`
    display: none;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid #D5C8C8B2;
    height: 100%;
    color: #4D4D4D;
    box-sizing: border-box;
    border-radius: ${props => props.isOpen ? '10px' : '0 0 10px 10px'};
    width: 238px;
    margin: 0 auto;

    @media (max-width: 577px) {
        display: flex;
    }
`

const Item = styled.div`
    font-family: 'Montserrat';
    font-size: 14px;
    padding: 25px 60px;
    background: ${props => props.isActive && '#EDE8E8'};
    cursor: pointer;
    width: 100%;
    text-align: center;
    box-sizing: border-box;
    text-transform: capitalize;
    width: 100%;
`

const ButtonUp = styled.button`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: 'Montserrat';
    font-size: 12px;
    padding: 6px 0;
    background: #D5C8C8B2;
    cursor: pointer;
    width: 100%;
    outline: none;
    border: none;
    box-sizing: border-box;
    text-align: center;
    border-radius: ${props => props.isOpen ? '9px 9px 0 0' : '0 0 9px 9px'};

`

const ButtonDown = styled.button`
    font-family: 'Montserrat';
    font-size: 12px;
    padding: 6px 0 ;
    background: #D5C8C8B2;
    cursor: pointer;
    box-sizing: border-box;
    width: 100%;
    outline: none;
    border: none;
    text-align: center;
    outline: none;
    border: none;
    box-sizing: border-box;
    text-align: center;
    align-items: center;
    justify-content: center;
    display: flex;
    border-radius: 0 0 9px 9px;
`

const ArrowImg = styled.img`
    padding: 0;
    width: 15px;
    display: block;
`

const ButtonText = styled.div`
    margin-bottom: 4px;
    font-weight: 500;
    color: #4D4D4D;
`

const VerticalFiltersMobile = ({items, currentFIlter}) => {
    const [isOpen, setIsOpen] = useState()
    const dispatch = useDispatch();
    const { t } = useTranslation()
    

    const filterSubmitHandler = (value) => {
        dispatch(setFilter({
            ...currentFIlter,
            subcathegory: value
        }));
    }

    console.log('currentFIlter.subcathegory', currentFIlter.subcathegory)

  return (
      <Root isOpen={isOpen}>
        {isOpen 
            ?
                <>
                    <ButtonUp isOpen={isOpen}> 
                        <ArrowImg alt='down' src={arrowDown}/>
                    </ButtonUp>
                    <Item onClick={() => filterSubmitHandler('')} isActive={!currentFIlter.subcathegory}>
                        {t('all')}
                    </Item>
                    {items.map((item) => (
                        <Item onClick={() => filterSubmitHandler(item)} isActive={currentFIlter.subcathegory === item}>
                            {t(item)}
                        </Item>
                    ))}
                    <ButtonDown onClick={() => setIsOpen(false)}>
                        <ArrowImg alt='down' src={arrowUp}/>
                    </ButtonDown>
                </>
            :
                <ButtonUp isOpen={isOpen} onClick={() => setIsOpen(true)}> 
                    <ButtonText>
                        {t('toChoseSubCategory')}
                    </ButtonText>
                    <ArrowImg alt='down' src={arrowDown}/>
                </ButtonUp>
        }
        
      </Root>
  )
}

export default VerticalFiltersMobile